import { useNavigate } from 'react-router-dom'
import { Button, EmptyState } from '@/design/components'

export function NotFound() {
  const navigate = useNavigate()
  return (
    <EmptyState
      size="page"
      title="Nie znaleziono strony"
      description="Adres nie istnieje albo moduł, do którego prowadzi, jest wyłączony dla Twojej roli."
      action={
        <Button variant="primary" onClick={() => navigate('/')}>
          Wróć na pulpit
        </Button>
      }
    />
  )
}
